import constants from 'constants/index'

const kindTranslation = (kind) => {
  return (kind && constants.audits.KIND_TRANSLATION[kind]) || 'Indefinido'
}

export default kindTranslation
